export class TimeSpotRuleExtentedSettings {
  constructor(
    public offsetFrom: number,
    public offsetTo: number,
  ) {}
}
export class TimeSpotRule {
  constructor(
    public timeSpotType: number,
    public text: string,
    public extentedSettings: TimeSpotRuleExtentedSettings = null,
  ) {}
}
